import "./Pagination.css"

export default function Pagination(props) {
    const items = props.items;
    const onPageClick = props.onPageClick;
    const onNextPageClick = props.onNextPageClick;
    const onPrevPageClick = props.onPrevPageClick;
    const currentPage = props.currentPage;
    const isPrevButtonDisabled = currentPage === 1;
    const isNextButtonDisabled = currentPage === items.length;

    const pagesJSX = items.map(function(value) {
        const isCurrentPageItem = value.pageNumber === currentPage;
        let className = "flex items-center justify-center px-4 h-10 leading-tight text-gray-500 border border-gray-300 hover:bg-gray-100 hover:text-gray-700"
        className += isCurrentPageItem ? " bg-primary-500 text-white" : " bg-white text-gray-500"
        return (
            <li key={value.pageNumber}>
                <button
                    onClick={onPageClick.bind(null, value.pageNumber)}
                    className={className}>
                    {value.pageNumber}
                </button>
            </li>
        )
    });

    return (
        <nav className="flex items-center justify-center">
            <ul className="flex items-center -space-x-px h-10 text-base">
                <li>
                    <button
                        disabled={isPrevButtonDisabled}
                        className="flex items-center justify-center px-4 h-10 ms-0 leading-tight text-gray-500 bg-white border border-e-0 border-gray-300 rounded-s-lg hover:bg-gray-100 hover:text-gray-700"
                        onClick={onPrevPageClick}
                    >
                        <span className="sr-only">Previous</span>
                        <svg className="w-2.5 h-2.5 rtl:rotate-180"
                             aria-hidden="true"
                             xmlns="http://www.w3.org/2000/svg"
                             fill="none"
                             viewBox="0 0 6 10"
                        >
                            <path stroke="currentColor"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M5 1 1 5l4 4"
                            />
                        </svg>
                    </button>
                </li>
                {
                    pagesJSX
                }
                <li>
                    <button
                        disabled={isNextButtonDisabled}
                        className="flex items-center justify-center px-4 h-10 leading-tight text-gray-500 bg-white border border-gray-300 rounded-e-lg hover:bg-gray-100 hover:text-gray-700"
                        onClick={onNextPageClick}>
                        <span className="sr-only">Next</span>
                        <svg className="w-2.5 h-2.5 rtl:rotate-180"
                             aria-hidden="true"
                             xmlns="http://www.w3.org/2000/svg"
                             fill="none"
                             viewBox="0 0 6 10"
                        >
                            <path stroke="currentColor"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="m1 9 4-4-4-4"
                            />
                        </svg>
                    </button>
                </li>
            </ul>
        </nav>
    )
}

export function createPaginationItem(pageNumber) {
    return {
        pageNumber: pageNumber,
    }
}